import { useCallback, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { getAlerts, removeAlert, setAlertVisibility } from '../../../reducers/Alerts';
import { FLOATING_ALERT_TIMING } from '../constants/floating_alert_timing';
const useAlertsList = () => {
  const alerts = useAppSelector(getAlerts);
  const dispatch = useAppDispatch();
  const alertsToBeRemoved = useRef([]);
  const dismissAlert = useCallback(id => {
    return () => {
      // allow the animation to complete before removing the alert
      dispatch(setAlertVisibility({
        id,
        visuallyHidden: true
      }));
      alertsToBeRemoved.current.push(setTimeout(() => {
        dispatch(removeAlert({
          id
        }));
      }, parseInt(FLOATING_ALERT_TIMING, 10)));
    };
  }, [dispatch]);
  useEffect(() => {
    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      for (const alertToBeRemoved of alertsToBeRemoved.current) {
        if (alertToBeRemoved) {
          clearTimeout(alertToBeRemoved);
        }
      }
    };
  }, []);
  return {
    alerts,
    dismissAlert
  };
};
export default useAlertsList;